<template>
	<div>
		<swiper class="swiper_tab04" :options="swiperOption_tab04" ref="mySwiper_tab04">
			<swiper-slide :key="index" v-for="(item,index) in list">
				<component :is="item.component"></component>
			</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	//二级导航组件 -- 纯爱
	import chunaigdca from '@/views/bookcity/chunai_gdca.vue';
	import chunaixdca from '@/views/bookcity/chunai_xdca.vue';
	import chunaihxca from '@/views/bookcity/chunai_hxca.vue';
	import chunaibh from '@/views/bookcity/chunai_bh.vue';
	export default {
		props: ['swiperIndexFirstSe03'],
		data() {
			const that = this
			return {
				list: [{
						component: chunaigdca
					},
					{
						component: chunaixdca
					},
					{
						component: chunaihxca
					},
					{
						component: chunaibh
					}
				],
				mySwiper: null,
				//轮播图配置
				swiperOption_tab04: {
					spaceBetween: 0,
					centeredSlides: true,
					direction: 'horizontal',
					autoplay: false,
					loop: false,
					threshold : 50,
					pagination: {
						el: '.swiper-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					observer: false,
					observeParents: false,
					// prevButton: ".swiper-button-prev",
					// nextButton: ".swiper-button-next",
					//滑动之后回调函数
					on: {
						slideChangeTransitionStart: function() {
							var swiper = that.$refs.mySwiper_tab04.$swiper;
							console.log(swiper.activeIndex, 'swiper.activeIndex')
							that.$emit('firSecondCateSlideTab03', swiper.activeIndex)
						},
					},
				},
			}
		},
		computed: {
			// 定义swiper，在下面就可以引用这个swiper了；
			swiper04: function() {
				return this.$refs.mySwiper_tab04.$swiper
			},
		},
		mounted() {
			this.swiper04.slideTo(localStorage.getItem('secondCategroy03') || 0);
		},
		watch: {
			swiperIndexFirstSe03(value, oldvalue) {
				// 接收 nav组件传过来的导航按钮索引，跳转到相应的内容区
				this.swiper04.slideTo(value, 0, false)
			}
		},
	}
</script>

<style>
</style>
